export default __webpack_public_path__ + "static/media/JKHInfoLogo.99cb3bc5.png";